export default __webpack_public_path__ + "static/media/Create-documentation.13471c8b.md";